import React from 'react';

import {pluralize} from 'BenchlingUtil';
import {ProcedureType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {CONDITIONS_LIMIT_MESSAGE} from 'studies/typed/shared/procedure-runs/execution-status/useMethodExecutionLimitState';
import {getProcedureRunConditionTextForProcedureType} from 'studies/TypedStudyUtils';
import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';

export default function MethodExecutionLimitError({
  replicateLimit,
  procedureType,
}: {
  replicateLimit: number;
  procedureType: ProcedureType;
}): JSX.Element {
  return (
    <InlineBanner
      bannerType={InlineBannerType.ERROR}
      text={
        `Cannot exceed ${replicateLimit} total ${pluralize(replicateLimit, 'replicate')}. ` +
        `Reduce number of ${getProcedureRunConditionTextForProcedureType(procedureType, {plural: true})} or replicates.`
      }
    />
  );
}

export function MethodExecutionConditionLimitError(): JSX.Element {
  return <InlineBanner bannerType={InlineBannerType.ERROR} text={`${CONDITIONS_LIMIT_MESSAGE}. `} />;
}
